var map = {
	"./08_animal.jpg": "726a",
	"./105_computergame.jpg": "decf",
	"./106_masterchef.jpg": "8c65",
	"./10_penguin.jpg": "d2ab",
	"./111_bones.jpg": "4b4d",
	"./116_planet.jpg": "4d42",
	"./119_marathon.jpg": "bd10",
	"./122_speed-skating.jpg": "610c",
	"./126_FIFA.jpg": "d79e",
	"./14_picasso.jpg": "c9f0",
	"./19_chickenrice.jpg": "6653",
	"./1_fish.jpg": "0659",
	"./20_kiwi.jpg": "90da",
	"./24_bed.jpg": "d6a2",
	"./25_age-cohort.jpg": "2436",
	"./29_men-or-women.jpg": "9783",
	"./34_online-gambling.jpg": "ab17",
	"./36_not-a-checkmate.jpg": "6b4f",
	"./41_help-counsellor.jpg": "fccd",
	"./42_scrabble-x.jpg": "dce2",
	"./44_flower.jpg": "6a82",
	"./48_lexus.jpg": "740b",
	"./51_boat-back.jpg": "7abc",
	"./52_chess.jpg": "b6a2",
	"./55_moby_machupichu.jpg": "798c",
	"./56_12apostles.jpg": "f421",
	"./57_currency.jpg": "415a",
	"./58_flag.jpg": "21a6",
	"./60_chand_baori.jpg": "7fe8",
	"./65_big-potato.jpg": "9bec",
	"./6_dogbreed.jpg": "0a09",
	"./71_french.jpg": "5099",
	"./72_explorer.jpg": "1141",
	"./75_harbourbridge.jpg": "bf1a",
	"./76_spacewoman.jpg": "dd8e",
	"./77_dinosaurs.jpg": "d8bc",
	"./82_movie_director.jpg": "cf2f",
	"./85_titanic.jpg": "47fd",
	"./88_musicterm.jpg": "98e9",
	"./89_beatles.jpg": "52db",
	"./91_bsb.jpg": "4030",
	"./92_instrument.jpg": "4714",
	"./94_spicegirls.jpg": "3255",
	"./95_justin.jpg": "56c1",
	"./question.jpg": "c893"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";